import { DataBean } from "../../DataBean";


export class ImpHealthIDCatalog extends DataBean {

    public async importHealthIDCatalog(idHealthIDType: any, filename: any, directory: any, dataStore: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importHealthIDCatalog_Number_String_String_String", [idHealthIDType, filename, directory, dataStore]);
    }

}